import React from 'react';
import './RollingTextButton.css';

const RollingTextButton = () => {
  return (
    <a href="https://wa.aisensy.com/aaa4ob" className="rolling-text-button" target="_blank" rel="noopener noreferrer">
      <span className="static-text">Calling: </span>
      <div className="rolling-text-container">
        <span className="roll-text">Creators</span>
        <span className="roll-text">Dreamers</span>
        <span className="roll-text">Makers</span>
        <span className="roll-text borntomake-text">Join #BornToMake</span>
      </div>
    </a>
  );
};

export default RollingTextButton;